import React from "react";

const ConfirmPage = () => {
  return (
    <div className="min-h-screen flex flex-col justify-center">
      <div className="text-center text-2xl font-bold">
        Your check-in is confirmed!
      </div>
    </div>
  );
};

export default ConfirmPage;
